// Module
var code = "<ul class=\"importer-upload-criteria\" style=\"width:400px\"> <li> Make sure all the following required columns are filled in:<br/> <ul class=\"criteria-field-list\"> <li>Email</li> <li>Permission</li> </ul> </li> </ul> ";
// Exports
module.exports = code;